module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACcAAAAtCAYAAAAtOHJTAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAQ1JREFUeNrM2cENwjAMBdBgMQAjMAIneoUR2IBNmIUJGKHiWE6MwgYQkDigUkKS/51vycolSp/qtrbUEADRdetVIISBzukZQBRuwQAa8Cw40MCVgAKN8BzDgAwcDMjCQYBMXDWQjasCeuCKgV64IqAnLhs4ixv3cV1WXvSQuf8WczsMl2sK18d1E/wjCbTQLpIlbolLAlvjfgIVcJNAFdxXoBJuBFTDfQAVcW/gSRX3/EDvTBT26hymClN7IUa91lRhKrjJ6cRUYa1xyXluHvMY8yw5CSNuQWw1dzSsRVn/hnnjsmCeuGyYF64I5oErhrFxVTAmrhrGwkFgDBwMhsZBYUgcHAYL1r+vhwADAImAic8Q4rULAAAAAElFTkSuQmCC"


/*****************
 ** WEBPACK FOOTER
 ** ./src/styles/next-hi.png
 ** module id = 176
 ** module chunks = 0
 **/